const triggerGetCustomerVerificationStatus = (sessionId, clientIp, accountNbr, host) => {
    const reqPayload = {
        security: {
            session: {
                id: sessionId
            },
            client_ip: clientIp,
            version: "2",
        },
        sender: {
            preferred_customer: {
                account_nbr: accountNbr
            }
        }
    };
    const requestOptions = {
        method: "POST",
        headers: {
            "accept": "application/json, text/plain, */*",
            "Content-Type": "application/json",
            "accept-language": "en-US,en;q=0.9"
        },
        body: JSON.stringify(reqPayload)
    };
    return fetchApiWu(`https://${host}/wudgtsrvs/mobiliser/rest/channel/GwpGetCustomerVerificationStatus?timestamp=${new Date().getTime()}`, requestOptions, "GwpGetCustomerVerificationStatus")
};